import React, { useState, useEffect } from 'react';
import './LanguageLab.css';

// Import images for Language Lab
import languagelab1 from '../assets/languagelab.jpeg';

const LanguageLab = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const languagelabImages = [languagelab1];

  useEffect(() => {
    setIsVisible(true);
    
    // Auto-slide images every 3 seconds
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => 
        prevIndex === languagelabImages.length - 1 ? 0 : prevIndex + 1
      );
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  const handleDotClick = (index) => {
    setCurrentImageIndex(index);
  };

  const handlePrevImage = () => {
    setCurrentImageIndex((prevIndex) => 
      prevIndex === 0 ? languagelabImages.length - 1 : prevIndex - 1
    );
  };

  const handleNextImage = () => {
    setCurrentImageIndex((prevIndex) => 
      prevIndex === languagelabImages.length - 1 ? 0 : prevIndex + 1
    );
  };

  return (
    <div className="langlab-container">
          {/* Banner Section with Background Image */}
      <section className="inner-bannerlib">
        <div className="banner-container">
          <h1>LANGUAGE LAB</h1>
        </div>
      </section>

      {/* Breadcrumb */}
      <section className="breadcrumb-section">
        <div className="breadcrumb-container">
          <ul className="breadcrumb-list">
            <li><a href="/">Home</a></li>
            <li>/</li>
            <li>Language Lab</li>
          </ul>
        </div>
      </section>
      {/* Main Content */}
      <div className="langlab-main-content">
        <div className="langlab-content-wrapper">
          {/* Left Side - Text Content */}
          <div className={`langlab-text-content ${isVisible ? 'langlab-visible' : ''}`}>
            <h2 className="langlab-main-heading">LANGUAGE LAB</h2>
            
            <p className="langlab-intro-text">
              Language is essential for expressing ideas, opinions, views, and emotions. One of the essential 
              qualities required today is the command over the English language. In other words, effective oral 
              communication is required for success in life. This is made possible by an English lab. The main 
              objective of this lab is to provide this facility to the student and to hone their skills.
            </p>

            <p className="langlab-section-text">
              Here at Bihani Children's Academy, the Language Lab consists of a teacher module and a student 
              module. The teacher module is provided with the control functions and the student module is 
              provided with the facility to receive recorded lessons and to listen to the lessons and 
              pronunciations. It is designed to enhance the overall communication skills amongst students 
              including pronunciation and accent. The course content of the English Lab has been developed 
              keeping in mind the difficulties that the students generally face.
            </p>

            <div className="langlab-feature">
              <h3 className="langlab-feature-title">Advanced Technology:</h3>
              <p className="langlab-feature-text">
                Our language lab is equipped with modern audio-visual equipment, digital language learning 
                software, and individual workstations that provide students with an immersive learning experience.
              </p>
            </div>

            <div className="langlab-feature">
              <h3 className="langlab-feature-title">Personalized Learning:</h3>
              <p className="langlab-feature-text">
                Each student can work at their own pace, practicing pronunciation, listening comprehension, 
                and speaking skills through interactive exercises and activities tailored to their learning level.
              </p>
            </div>
          </div>

          {/* Right Side - Image Slider */}
          <div className={`langlab-image-slider ${isVisible ? 'langlab-visible' : ''}`}>
            <div className="langlab-slider-container">
              {languagelabImages.map((image, index) => (
                <img
                  key={index}
                  src={image}
                  alt={`Language Lab ${index + 1}`}
                  className={`langlab-slider-image ${
                    index === currentImageIndex ? 'langlab-active' : ''
                  }`}
                />
              ))}
              
            </div>
          </div>
        </div>

        {/* Additional Features Section */}
        <div className={`langlab-additional-section ${isVisible ? 'langlab-visible' : ''}`}>
          <div className="langlab-feature">
            <h3 className="langlab-feature-title">Interactive Sessions:</h3>
            <p className="langlab-feature-text">
              Students participate in interactive language activities, role-plays, group discussions, and 
              presentations that build confidence in using English in real-life situations.
            </p>
          </div>

          <div className="langlab-feature">
            <h3 className="langlab-feature-title">Recording and Playback:</h3>
            <p className="langlab-feature-text">
              Students can record their own voice, compare it with native speakers, and identify areas for 
              improvement. This self-assessment feature helps students track their progress over time.
            </p>
          </div>

          <div className="langlab-feature">
            <h3 className="langlab-feature-title">Multimedia Resources:</h3>
            <p className="langlab-feature-text">
              The lab provides access to a rich library of audio books, podcasts, videos, and interactive 
              language games that make learning engaging and enjoyable.
            </p>
          </div>

          <p className="langlab-conclusion-text">
            Our Language Lab is designed to transform students into confident communicators. By combining 
            technology with proven teaching methodologies, we help students develop the language proficiency 
            they need to succeed in their academic and professional lives.
          </p>
        </div>
      </div>
    </div>
  );
};

export default LanguageLab;